var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._l(_setup.legends, function (legend, index) {
      return _c(_setup.FormFieldset, {
        key: legend,
        attrs: {
          "form-id": _vm.formId,
          "is-first": index === 0,
          "is-last": index === _setup.legends.length - 1,
          legend: legend,
          "show-legends": _vm.showLegends,
          "hide-help-text": _vm.hideHelpText,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }